// extracted by mini-css-extract-plugin
export default {"noLinkStyle":"Sidebar_noLinkStyle__pPR9P","heading":"Sidebar_heading__J82hd","sidebar":"Sidebar_sidebar__sPXm6"};